import i18n from 'services/base/i18n';

export default {
  severityVeryLow:  () => i18n.pgettext('Issues|Severity', 'Very Low'),
  severityLow:      () => i18n.pgettext('Issues|Severity', 'Low'),
  severityMedium:   () => i18n.pgettext('Issues|Severity', 'Medium'),
  severityHigh:     () => i18n.pgettext('Issues|Severity', 'High'),
  severityCritical: () => i18n.pgettext('Issues|Severity', 'Critical'),
};
